import { FileClient, RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B080030FindRequest = { shukashijiYmd: string } & Partial<{
  shijikaisu: string;
  batchNo: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B080030FindResponse = {
  shukashijiYmd: string;
  shijikaisu: string;
  batchNo: string;
  batchNm: string;
  tenposu: string;
  shohinsu: string;
  shukajokyo: string;
  pickinghako: string;
  cancelKbn: string;
  version: string;
};

export const B080030Find = (props: B080030FindRequest) => {
  return RestClient.get<PageableResponse<B080030FindResponse[]>>(
    "b080030/find",
    {
      params: props,
    }
  );
};

export type B080030PrintDetailRequest = Partial<{
  shukashijiYmd: string;
  shijikaisu: string;
  batchNo: string;
  shukajokyo: number;
  cancelKbn: number;
  version: string;
}>;

export type B080030PrintRequest = {
  b080030PrintRequestChildList: B080030PrintDetailRequest[];
};

//印刷処理
export const B080030Print = (props: B080030PrintRequest) => {
  return FileClient.put("b080030/print", props);
};
